import { render, staticRenderFns } from "./TabDocumento.vue?vue&type=template&id=59f7f41b&"
import script from "./TabDocumento.vue?vue&type=script&lang=js&"
export * from "./TabDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports